import createEnum from "../enum";
import { language } from "../../language/get";
var lan = language();

/**
 * 展会状态
 */
const [ ExhibitionType, ExhibitionTypeEnum ] = createEnum([
    {
        name: lan.state0,
        type: null,
    },
    {
        name: lan.state1,
        type: 1,
        enum: "NotAlready"
    },
    {
        name: lan.state2,
        type: 2,
        enum: "ONGOING"
    },
    {
        name: lan.state3,
        type: 3,
        enum: "HAS_ENDED"
    },
    {
        name: lan.state3,
        type: 4,
        enum: "END_HAS_ENDED"
    },
]);

export { ExhibitionType, ExhibitionTypeEnum };


const [ ExhibitionHandle, ExhibitionHandleEnum ] = createEnum([
    {
        name: "观展",
        type: 1,
        enum: "VIEW_EXH"
    },
    {
        name: "参展",
        type: 2,
        enum: "JOIN_EXH"
    },
    {
        name: "进入会场",
        type: 3,
        enum: "ENTER_ROOM"
    },{
        name: "购票",
        type: 4,
        enum: "BUY_TICKET"
    }
]);
export {ExhibitionHandle, ExhibitionHandleEnum}


const [ExhibitionForum] = createEnum([
    {
        name: lan.state0,
        type: 5,
    },
    {
        name: lan.state1,
        type: 1,
        enum: "NotAlready"
    },
    {
        name: lan.state2,
        type: 2,
        enum: "ONGOING"
    }
]);
export { ExhibitionForum }


const loginType = {
    LOGIN_ACCOUNT: 0, //账号
    LOGIN_TICKET: 1  //票号
}
export {loginType}


const [ ExhType ] = createEnum([
    {
        name: lan.state0,
        type: null,
    },
    {
        name: lan.state1,
        type: 1,
        enum: "NotAlready"
    },
    {
        name: lan.state2,
        type: 2,
        enum: "ONGOING"
    },
    {
        name: lan.state3,
        type: 3,
        enum: "HAS_ENDED"
    }
]);
export {ExhType}


const [ExhIndexType] = createEnum([
    {
        //全部
        name: lan.state0,
        type: null,
    },
    {
        //招商中
        name: lan.exState,
        type: 0,
    },
    {
        //预约中
        name: lan.exState1,
        type: 1,
    },
    {
        //进行中
        name: lan.exState2,
        type: 2,
    },
    {
        //已结束
        name: lan.exState3,
        type: 3,
    }
])
export {ExhIndexType}